import { PostHogProvider } from 'posthog-js/react'

import { isProduction } from '@/lib/utils'

function removeSensitiveParams(url: string) {
  if (url.indexOf('?') === -1) return url

  const queryString = url.split('?')[1]
  const searchParams = new URLSearchParams(queryString)

  // Sensitive parameters to be hidden
  const sensitiveParams = [
    'otp',
    'email',
    'id',
    'token',
    'identity',
    'business',
  ]

  sensitiveParams.forEach((param) => {
    if (searchParams.has(param)) {
      searchParams.set(param, 'masked')
    }
  })

  return url.split('?')[0] + '?' + searchParams.toString()
}

type Props = {
  children: React.ReactNode
}

export function PostHogCustomProvider({ children }: Props) {
  if (!isProduction()) {
    return <>{children}</>
  }

  return (
    <PostHogProvider
      apiKey={import.meta.env.VITE_POSTHOG_API_KEY}
      options={{
        api_host: import.meta.env.VITE_POSTHOG_API_HOST,
        sanitize_properties(properties) {
          if (properties[`$current_url`]) {
            properties[`$current_url`] = removeSensitiveParams(
              properties[`$current_url`],
            )
          }
          return properties
        },
      }}
    >
      {children}
    </PostHogProvider>
  )
}
